// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "" + ({"197":"75fc9c18","293":"component---src-pages-index-js","518":"8a28b14e"}[chunkId] || chunkId) + "." + {"197":"0427ca9b9604db65134a","293":"e206333622e40b98b426","518":"045093c63e2bb0b4174f","779":"32dbd901e0ad2e5ed34d"}[chunkId] + ".js";
};